import { useParams } from "react-router-dom";
import Cohort from "cohorts/types/interfaces/cohort";
import { useFetcher } from "~/hooks/useFetcher";

const useCohort = () => {
  const { cohortId } = useParams();

  const resp = useFetcher<Cohort>(
    cohortId && cohortId !== "new" ? `/api/cohort-explorer/cohorts/${cohortId}` : null,
    {
      // TODO: Replace polling with WS once we've ironed out race condition and sticky session issues
      refreshInterval: (data) =>
        data?.pending || data?.pending_llm || data?.pending_count ? 1000 : 0,
      revalidateOnFocus: false,
    }
  );

  // Don't fetch a cohort when the cohortId is "new"
  // This is used to show a loading interstitial page while waiting for
  // backend response of creating new cohort from dataset page
  if (cohortId === "new") {
    return { ...resp, isLoading: true };
  }

  return resp;
};

export default useCohort;
